module.exports = __webpack_public_path__ + "img/1e20194.jpg";